export default __webpack_public_path__ + "static/media/play-circle-solid.efaa0203.svg";